var _path, _path2, _g, _rect, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "white",
    fillOpacity: 0.38
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2870_6230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2870_6230)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "rgba(0, 0, 0, 0.87)",
    fillOpacity: 0.08
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2870_6230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2870_6230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5C18.9 19.5 17.9583 19.1083 17.175 18.325C16.3917 17.5417 16 16.6 16 15.5C16 14.4 16.3917 13.4583 17.175 12.675C17.9583 11.8917 18.9 11.5 20 11.5C21.1 11.5 22.0417 11.8917 22.825 12.675C23.6083 13.4583 24 14.4 24 15.5C24 16.6 23.6083 17.5417 22.825 18.325C22.0417 19.1083 21.1 19.5 20 19.5ZM14 27.5C13.45 27.5 12.9792 27.3042 12.5875 26.9125C12.1958 26.5208 12 26.05 12 25.5V24.7C12 24.1333 12.1458 23.6125 12.4375 23.1375C12.7292 22.6625 13.1167 22.3 13.6 22.05C14.6333 21.5333 15.6833 21.1458 16.75 20.8875C17.8167 20.6292 18.9 20.5 20 20.5C21.1 20.5 22.1833 20.6292 23.25 20.8875C24.3167 21.1458 25.3667 21.5333 26.4 22.05C26.8833 22.3 27.2708 22.6625 27.5625 23.1375C27.8542 23.6125 28 24.1333 28 24.7V25.5C28 26.05 27.8042 26.5208 27.4125 26.9125C27.0208 27.3042 26.55 27.5 26 27.5H14Z",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.cd146b4c9472b692293fac2907e05123.svg";
export { ForwardRef as ReactComponent };